require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-our-favorite-tech-podcasts-for-2021.json") })
        }
      }, "path---blog-our-favorite-tech-podcasts-for-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-our-favorite-tech-podcasts-for-2021!./.cache/json/blog-our-favorite-tech-podcasts-for-2021.json
// module id = 1026
// module chunks = 231608221292675